import React, { useState } from 'react';
import { cn } from '../../../utils/classnames';
import { formatPhone } from '../../../utils/masks';
import ClientStatusBadge from '../../../components/ui/badges/ClientStatusBadge';
import DynamicActionButton from '../../../components/ui/buttons/DynamicActionButton';
import ContractSendModal from './ContractSendModal';

const MyClientRow = ({ client, index, onContractSent }) => {
  const isEven = index % 2 === 0;
  const bgClass = isEven ? 'bg-white' : 'bg-transparent';
  const [contractModalOpen, setContractModalOpen] = useState(false);

  const handleResendContract = (e) => {
    e.preventDefault();
    setContractModalOpen(true);
  };

  return (
    <tr className="text-blueDarker">
      <td className={cn('pl-4 py-4 m-1 rounded-l-xl', bgClass)}>
        <ClientStatusBadge status={client.status} tStatus={client.tStatus} />
      </td>

      <td className={cn('text-lg font-semibold py-4', bgClass)}>
        <div className="flex items-center gap-2">
          <div className="truncate whitespace-nowrap" title={client.name}>
            {client.name}
          </div>
        </div>
      </td>

      <td className={cn('pl-10 text-base', bgClass)}>
        <div className="truncate whitespace-nowrap" title={client.updatedAt}>
          {client.updatedAt}
        </div>
      </td>

      <td className={cn('pr-4 rounded-r-xl', bgClass)} style={{ width: '560px', minWidth: '520px' }}>
        <div className="flex gap-2 justify-end items-center flex-nowrap overflow-x-auto md:overflow-visible no-scrollbar">
          <a href={`/app/planner/client/${client.id}/profile?from=commercial.my_clients`}>
            <DynamicActionButton state={'simple'}>DOCUMENTAÇÃO COMPLETA</DynamicActionButton>
          </a>
          <DynamicActionButton state={'simple'} className="w-44" onClick={handleResendContract}>
            {client.docusignId ? 'REENVIAR CONTRATO' : 'ENVIAR CONTRATO'}
          </DynamicActionButton>
          <a href={`/app/planner/client/${client.id}/dashboard?from=commercial.my_clients`}>
            {/* <a href={`/planner/cliente/${client.id}`}> */}
            <DynamicActionButton state={'default'}>MAIS INFORMAÇÕES</DynamicActionButton>
          </a>
        </div>
        {contractModalOpen && (
          <ContractSendModal
            client={client}
            onClose={() => setContractModalOpen(false)}
            onSent={(data) => onContractSent(client.id, data)}
          />
        )}
      </td>
    </tr>
  );
};

export default MyClientRow;
